import { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import { updateReportingRequest as ticketUpdate } from '../state';
import { updateReportingRequest as recurringTaskUpdate } from '../../recurringTasks/state';
import { ReportingRequestView } from '../../../types/shared/accessRequestTypes';
import { EditorMode } from '../types/editorTypes';

/**
 * Custom hook that abstracts Redux state selection and dispatch for
 * Reporting editors. Returns the current request data and
 * a mode-aware update function.
 */
export const useReportingEditor = (mode: EditorMode) => {
  const dispatch = useAppDispatch();

  const request = useAppSelector(state =>
    mode === 'ticket'
      ? state.ticket.currentTicket?.reportingRequest
      : state.recurringTask.currentRecurringTask?.reportingRequest
  );

  const updateRequest = useCallback(
    (update: Partial<ReportingRequestView>) => {
      if (mode === 'ticket') {
        dispatch(ticketUpdate(update));
      } else {
        dispatch(recurringTaskUpdate(update));
      }
    },
    [dispatch, mode]
  );

  return { request, updateRequest };
};
